import React from 'react';
import { Link } from 'react-router-dom';

export default function AdminEditToolbar({ editMode, setEditMode }) {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-[60] flex flex-wrap items-center justify-center gap-3 px-4 py-2 bg-forest border-t border-gold/30 text-canvas text-fluid-sm shadow-lg"
      role="status"
      aria-live="polite"
    >
      <span className="font-semibold text-gold">Editing enabled</span>
      <label className="inline-flex items-center gap-2 cursor-pointer min-h-[44px]">
        <input
          type="checkbox"
          checked={editMode}
          onChange={(e) => setEditMode(e.target.checked)}
          className="w-4 h-4 accent-gold"
        />
        <span>Show edit controls</span>
      </label>
      <Link to="/admin" className="min-h-[44px] inline-flex items-center text-gold font-bold hover:underline">
        Admin dashboard →
      </Link>
    </div>
  );
}
